/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendInvoiceEmailRequest
 */
export interface SendInvoiceEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendInvoiceEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the SendInvoiceEmailRequest interface.
 */
export function instanceOfSendInvoiceEmailRequest(value: object): value is SendInvoiceEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SendInvoiceEmailRequestFromJSON(json: any): SendInvoiceEmailRequest {
    return SendInvoiceEmailRequestFromJSONTyped(json, false);
}

export function SendInvoiceEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendInvoiceEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function SendInvoiceEmailRequestToJSON(json: any): SendInvoiceEmailRequest {
    return SendInvoiceEmailRequestToJSONTyped(json, false);
}

export function SendInvoiceEmailRequestToJSONTyped(value?: SendInvoiceEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

